import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Actions from "@my-dld/actions";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { trackEvent } from "@my-dld/utils/Analytics";
import { logout } from "@10x/sso";
import urlParser from "urijs";
import { I8N, StringUtil } from "@eres/core";
import { getLogoutUrl } from "@eres/ssoapi/api";
import { IAppLoginState } from "../Login";
import * as base64 from "js-base64";
import { isUaePassEnabled, isUaePassUser } from "@my-dld/utils/Utils";
import { getAppServices } from "@10x/coreapp/index";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

interface State {
	isReady: boolean;
	goToUaePass: boolean;
	reLoginModule?: string;
}

interface Props extends RoutedViewProps<{ from?: string }> {
}

class Logout extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let ready = true;
		let goToUaePass = false;
		if ( StringUtil.isEmptyStringOrNull( this.props.location.search ) ) {
			if ( isUaePassEnabled() && isUaePassUser() ) {
				showLoading();
				goToUaePass = true;
			}
		} else {
			let x = urlParser( this.props.location.search ).query( true ) as any;
			if ( x.state ) {
				const state = JSON.parse( base64.decode( x.state ) ) as IAppLoginState;
				const isFromUaePass = state && state.module === "uaepass" && state.mode === "logout";
				if ( !isFromUaePass ) {
					if ( isUaePassEnabled() && isUaePassUser() ) {
						showLoading();
						goToUaePass = true;
					}
				}
			}
		}
		this.state = {
			isReady: ready,
			goToUaePass: goToUaePass,
			reLoginModule: props.match.params.from ?? "",
		};
	}

	render() {
		if ( !this.state.isReady || this.state.goToUaePass )
			return <React.Fragment/>;
		return (
			<React.Fragment>
                <div className="auth-container">
                    <div className="container mw-1100">
                        <div className="row g-0">
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 m-auto">
                                <div className="auth-container-form card">
                                    <div className="icon-modal-wrap svgsuccess">
                                        <i className="material-icons-outlined">check_circle</i>
                                    </div>
                                    <div className="text-center my-3">
										{ Strings.you_have_successfully_logedout }
									</div>
                                    <div className="text-center"><button
                                        className="btn btn_1 btn_style1"
                                        onClick={this.doLogin}>{Strings.login_again}</button></div>
								</div>

							</div>

						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	componentDidMount() {
		if ( !this.state.isReady )
			return;
		if ( this.state.goToUaePass ) {
			const ln = I8N.locale();
			const appState: IAppLoginState = {
				module: "uaepass",
				sso: this.state.reLoginModule === "sso",
				ln: ln,
				mode: "logout"
			};
			const state = base64.encode( JSON.stringify( appState ) );
			const passUrl = getLogoutUrl( ln, state );
			window.location.replace( passUrl );
			return;
		}
		getAppServices().storeService.dispatch( {
			type: Actions.USER_LOGGED_OUT,
		} );
		trackEvent( "Login", "Logout" );
		if ( !isUaePassEnabled() ) {
			showLoading();
			const onLogout = () => {
				hideLoading();
				// window.location.href = AppConstants.rootUrlLocale;
			};
			logout().then( onLogout ).catch( onLogout );
		} else {
			logout().then().catch();
		}
	}

	doLogin = () => {
		let path = "/login";
		if ( !isEmptyStringOrNull( this.state.reLoginModule ) ) {
			path = path + "/" + this.state.reLoginModule;
		}
		this.props.history.replace( {
			pathname: path,
		} );
	};
}

export default Logout;
